<template>
  <div data-dusk="tab-group" :id="id" ref="self" class="tabs">
    <div class="tabs-row">
      <slot :go-to-tab="goToTab"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabGroup.vue",
  emits: ['go-to-tab', 'input'],
  props: {
    id: {
      required: false,
      type: [String, Number]
    },
    value: {
      required: false,
      type: [String, Number],
    }
  },
  data() {
    return {
      activeTabIndex: 0,
      tabsCollection: null,
      contentCollection: null,
      contentWrapper: null,
    }
  },
  mounted() {
    // If no id passed select first that is found.
    this.contentWrapper = document.getElementsByClassName('tab-content-wrapper')[0];
    if (this.id) {
      this.contentWrapper = document.querySelector('.tab-content-wrapper#' +  this.id);
    }
    this.initializeTabs();
    // If no elements could be found, try waiting for them.
    if (this.contentCollection.length === 0) {
      const observer = new MutationObserver(this.initializeTabs);
      observer.observe(this.contentWrapper, {
        childList: true,
        subtree: true,
      });
    }
  },
  beforeUnmount() {
    for(let i= 0; i< this.subTabs.length; i++) {
      this.tabsCollection[i].removeEventListener('click');
    }
  },
  methods: {
    initializeTabs() {
      this.tabsCollection = this.$refs.self.getElementsByClassName('tab');
      this.contentCollection = this.contentWrapper.getElementsByClassName('tab-content');
      if (this.contentCollection.length === 0) return;
      for(let i = 0; i < this.tabsCollection.length; i++) {
        this.tabsCollection[i].addEventListener('click', () => this.onTabClick(i) );
      }
      this.onTabClick(this.activeTabIndex);
    },
    onTabClick(index) {
      if (!this.tabContentExists(index)) return;
      this.activeTabIndex = index;
      this.emitActiveTabKey();
      this.setActiveContent();
      this.setActiveTab();
    },
    resetTabContentClasses() {
      for(let i = 0; i < this.contentCollection.length; i++) {
        this.contentCollection[i].classList.remove('active');
      }
    },
    resetSubTabClasses() {
      for(let i = 0; i < this.tabsCollection.length; i++) {
        this.tabsCollection[i].classList.remove('active');
      }
    },
    setActiveContent() {
      this.resetTabContentClasses();
      this.contentCollection[this.activeTabIndex].classList.add('active');
    },
    emitActiveTabKey() {
      if (this.contentCollection[this.activeTabIndex].hasAttribute('id')) {
        const activeKey = this.contentCollection[this.activeTabIndex].getAttribute('id');
        this.$emit('input', activeKey);
      }
    },
    setActiveTab() {
      this.resetSubTabClasses();
      this.tabsCollection[this.activeTabIndex].classList.add('active');
    },
    tabContentExists(i) {
      return !!this.contentCollection[i];
    },
    goToTab(tabIndex) {
      this.activeTabIndex = tabIndex;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.tabs {
  display: flex;
  flex-direction: column;
  width: 100%;

  .tabs-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $spacing-md;
    margin: 0 $spacing-xxl;
    overflow: hidden;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .content-slot {
    width: 100%;
  }
}
</style>
<style lang="scss">
@import "~@/_default.scss";

.tab-content-wrapper {
  .tab-content {
    display: none;
    width: 100%;
  }
  .tab-content.active {
    display: inherit;
  }
}

</style>
